
import { CustomToastComponent } from "@/components/shared";
import {
  FetchTenderByIdDocument,
  MarkOrganizationsAsNotSubmittingDocument,
  MarkOrganizationsAsNotSubmittingMutation,
  MarkOrganizationsAsNotSubmittingMutationVariables,
} from "@/graphql/__generated__/graphql";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

/**
 * Custom hook for marking organizations as not submitting and handling the necessary cache updates.
 * @returns {Object} - Contains the markOrganizationsAsNotSubmittingMutation function, loading state, and error state.
 */
export default function useMarkOrganizationsAsNotSubmittingMutationHook() {
  const { t } = useTranslation(["toasts"]);
  const { tenderID } = useParams<{ tenderID: string }>();

  const [markOrganizationsAsNotSubmittingMutation, { loading, error }] =
    useMutation<MarkOrganizationsAsNotSubmittingMutation, MarkOrganizationsAsNotSubmittingMutationVariables>(MarkOrganizationsAsNotSubmittingDocument, {
      onCompleted: () => {
        toast(CustomToastComponent, {
          toastId: "organizations-not-submitting-success",
          data: {
            title: t("toasts.organizationsmarkedasnotsubmitting"),
            type: "success",
          }
        });
      },
      refetchQueries: [
        {
          query: FetchTenderByIdDocument,
          variables: { id: Number(tenderID) },
        },
      ],
    });

  return {
    markOrganizationsAsNotSubmittingMutation,
    loading,
    error,
  };
}
